




import Vue from 'vue'
import { Action, Getter } from 'vuex-class'
import { mapState, mapMutations } from 'vuex'
import Component from 'vue-class-component'

// Vuex + typescript setup guide: https://codeburst.io/vuex-and-typescript-3427ba78cfa8
@Component({
  computed: {
    ...mapState({
      initLoad: (state: any): string => state.context.initLoad,
      loginTimeout: (state: any): string => state.context.config.loginTimeout
    })
  }
})
export default class App extends Vue {
  loginTimeout: number

  @Action('setInitIsLoading', { namespace: 'context' }) 'setInitIsLoading': void
  @Action('findExistingUserByDeviceId', { namespace: 'context' }) 'findExistingUserByDeviceId': any
  @Action('setDidAuthTokens', { namespace: 'context' }) 'setDidAuthTokens': any
  @Action('setupApplication', { namespace: 'context' }) setupApplication: any
  @Action('setTheme', { namespace: 'theme' }) 'setTheme': any

  beforeMount () {
    this.setupApplication(this.$route.query)
    this.setTheme(this.$route.query)

    // Do we have a saved authToken in sessionStorage? And was it last used within the configured time? (Default 30min)
    // If we do, we autoLogin the user again. Basically it means they've logged in once and then refreshed the browser
    if (this.existingAuthToken) {
      const didAccessToken = JSON.parse(sessionStorage.getItem('didAccessToken'))
      this.setDidAuthTokens({ access_token: didAccessToken.token, id_token: null })
    } else {
      // Otherwise we run the regular flow - check if user has logged in before, i.e if their deviceId is known
      // But we gotta let the piq_dId to be generated and set first.
      setTimeout(() => {
        this.findExistingUserByDeviceId()
      }, 500)
    }
  }

  get existingAuthToken () {
    const didAccessToken = JSON.parse(sessionStorage.getItem('didAccessToken'))
    if (didAccessToken && didAccessToken.token) {
      const maxTime = this.loginTimeout * 60 * 1000 // defaults to 5 min (configurable via loginTimeout)
      const lastUsed = new Date(didAccessToken.lastUsed)
      const now = new Date()

      const timeSinceUse = Math.abs(now.getTime() - lastUsed.getTime())
      return timeSinceUse < maxTime
    } else {
      return false
    }
  }
}
